import { replace } from 'connected-react-router';

import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';
import { connectedReduxRedirect } from 'redux-auth-wrapper/history4/redirect';

import { isAuthenticated, getDatasetId } from './selectors';

export const userIsAuthenticatedWithDataset = connectedReduxRedirect({
  redirectPath: '/login',
  authenticatedSelector: (state) => {
    const authenticated = Boolean(isAuthenticated(state) && getDatasetId(state));
    return authenticated;
  },
  authenticatingSelector: () => false,
  redirectAction: replace,
  wrapperDisplayName: 'UserIsAuthenticatedWithDataset',
});

export const visibleWhenAuthenticated = connectedAuthWrapper({
  authenticatedSelector: (state) => isAuthenticated(state),
  wrapperDisplayName: 'VisibleWhenAuthenticated',
});

export const isAuthenticatedWithDatasetOrElse = (Component, ElseComponent) => connectedAuthWrapper({
  authenticatedSelector: (state) => {
    const authenticated = Boolean(isAuthenticated(state) && getDatasetId(state));
    return authenticated;
  },
  FailureComponent: ElseComponent,
  wrapperDisplayName: 'AuthenticatedWithDatasetOrElse',
})(Component);

export const isAuthenticatedOrElse = (Component, ElseComponent) => connectedAuthWrapper({
  authenticatedSelector: (state) => {
    const authenticated = Boolean(isAuthenticated(state));
    return authenticated;
  },
  FailureComponent: ElseComponent,
  wrapperDisplayName: 'AuthenticatedOrElse',
})(Component);
